import React from 'react';

import Tag from './AbstractTag';

Tag.parser.registerTag(
  'h4',
  class extends Tag {
    constructor(renderer, settings = {}) {
      super(renderer, settings);

      this.STRIP_OUTER = true;
    }

    toReact() {
      return <h4>{this.getComponents()}</h4>;
    }
  }
);
